function parseBooleanEnv(
  value: string | undefined,
  defaultValue: boolean
): boolean {
  if (value === undefined) {
    return defaultValue;
  }
  const normalized = value.trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(normalized)) {
    return true;
  }
  if (['0', 'false', 'no', 'off'].includes(normalized)) {
    return false;
  }
  return defaultValue;
}

export const FEATURE_FLAGS = {
  adminBookingProvidersV1: parseBooleanEnv(
    import.meta.env.VITE_ADMIN_BOOKING_PROVIDERS_V1,
    false
  ),
  adminSchedulerV1: parseBooleanEnv(
    import.meta.env.VITE_ADMIN_SCHEDULER_V1,
    false
  ),
  adminSchedulerCrudV1: parseBooleanEnv(
    import.meta.env.VITE_ADMIN_SCHEDULER_CRUD_V1,
    false
  ),
} as const;

export type FeatureFlagName = keyof typeof FEATURE_FLAGS;

export function isFeatureEnabled(name: FeatureFlagName): boolean {
  return FEATURE_FLAGS[name];
}
